export default __webpack_public_path__ + "static/media/placeholder_dummy2016-personaltrainer01-de.fa688a8a.png";